import React from 'react'
import { useQrcodeAssetId } from '../_load/QrcodeLoader'
import AssetPageHeader from './linktree/AssetPageHeader'
import LinkTreeItemsLoader from './linktree/_load/LinkTreeItemsLoader'
import LinkTreeMenu from './linktree/LinktreeMenu'
import AssetLoader from '../_load/AssetLoader'

const AssetPage = () => {
  const assetId = useQrcodeAssetId()

  return (
    <AssetLoader id={assetId}>
      <AssetPageHeader />
      <LinkTreeItemsLoader>
        <LinkTreeMenu />
      </LinkTreeItemsLoader>
    </AssetLoader>
  )
}

export default AssetPage
